import http from "../http";

export default {
  /** 按开通人分组分页查询 */
  pageByGroup(params) {
    return http.get("/work_order/softwareInfo/handlers/pageByGroup", {
      params,
    });
  },
  /** 软件下拉选项 */
  getSoftwareDropdown() {
    return http.get("/work_order/softwareInfo/dropdown");
  },
  /** 开通人列表（已绑定软件的开通人，去重） */
  getHandlerList() {
    return http.get("/work_order/softwareInfo/handlers/list");
  },
  /** 按软件ID列表批量关联开通人 */
  bindBySoftwareIds(data) {
    return http.post("/work_order/softwareInfo/handlers/bindBySoftwareIds", data);
  },
  /** 按开通人批量关联软件ID */
  batchBind(data) {
    return http.post("/work_order/softwareInfo/handlers/batchBind", data);
  },
  /** 按开通人取消全部软件关联 */
  clearAll(data) {
    return http.post("/work_order/softwareInfo/handlers/clearAll", data);
  },
};
